export default __webpack_public_path__ + "static/media/password-eye-closed.55f26b56.svg";